<template>
    <span>
        <span class="clock ml-5" :id="id" tabindex="0"></span>
        <b-popover :target="id" placement="bottom" triggers="click blur">
            <template v-slot:content>
                <div class="popover-content">
                    <span class="clinic"></span>
                    <div class="ml-15 text-uppercase">
                        {{ toUserLocalTime(answer) }}
                    </div>
                </div>
                <div class="popover-content">
                    <span class="utc-globe"></span>
                    <div class="ml-15 text-uppercase">
                        {{ new Date(answer) | dateInUTC }}
                    </div>
                </div>
            </template>
        </b-popover>
    </span>
</template>
  
<script>
import moment from "moment";

export default {
    name: "clock-icon-popup",
    props: {
        answer: { type: String, default: "" },
        id: { type: String, default: "" },
    },
    methods: {
        toUserLocalTime(timeString) {
            const localObj = moment.utc(timeString).local();
            const formatedTime = localObj.format("DD MMM YYYY, hh:mm");
            const meridiem = localObj.format("A");
            const timeZone = moment.tz.guess();
            const time = new Date();
            const timeZoneOffset = time.getTimezoneOffset();
            const abbr = moment.tz.zone(timeZone).abbr(timeZoneOffset);
            return `${formatedTime} ${meridiem} ${abbr}`;
        },
    }
};
</script>
<style lang="scss" src="@/assets/table-styling.scss"></style>
